// Tiny pub/sub so any module (including non-React code) can raise a toast.
// `options.action` = { label, onClick } renders a text button in the toast
// (used for undo after removing an entry).
let nextId = 1;
const listeners = new Set();

export const toast = (message, type = 'error', options = {}) => {
  listeners.forEach((fn) => fn({ id: nextId++, message, type, action: options.action || null }));
};

export const onToast = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
